import {
  BooleanInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required,
  FunctionField,
  FormDataConsumer
} from 'react-admin';
import { CustomEditor, UploadImageInput } from '../../components';

export default function AwardsForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        fullWidth
        autoComplete="off"
        label="Título"
        source="title"
        validate={[required()]}
      />

      <UploadImageInput
        fullWidth
        label="Foto"
        source="photo"
        mimeTypes={['image/jpeg']}
        upploadOptions={{
          maxSize: [616, 382]
        }}
        
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de ?x?px."
      />

      <BooleanInput label="Destaque" source="featured" />

      <BooleanInput label="Exibir página detalhada?" source="hasDetail" />

      <FormDataConsumer>
        {({ formData }) =>
          formData.hasDetail && (
            <CustomEditor
              fullWidth
              label="Texto"
              source="text"
              validate={[required()]}
            />
          )
        }
      </FormDataConsumer>

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
